import { FileSelect } from "designSystem/index";
import React from "react";

export default () => {
	const onFileSelect = (file) => {
		alert(`${file.name} selected.`);
	};

	return (
		<FileSelect onFileSelect={onFileSelect} />
	);
};